// DEPENDENCIES
import React from 'react';
import Modal from 'react-modal';
import SVGInline from "react-svg-inline"

// svgs
import pianoPinkMugicsSVG from '../inlineSVGs/pianoPinkMugicsSVG';
import bandMugicsSVG from '../inlineSVGs/bandMugicsSVG';
import tieMugicsSVG from '../inlineSVGs/tieMugicsSVG';
import scopWhiteTxtSVG from '../inlineSVGs/scopWhiteTxtSVG';
import milkcartSVG from '../inlineSVGs/milkcartSVG';
import closeCrossSVG from '../inlineSVGs/closeCrossSVG';

// INNER IMPORTS
import { LIVE_MUSIC, SERVICE, BAND, MUSICIAN } from '../../consts';
import './Participate.css';

const ParticipateModal = props => (
    <div className="participate">
        <Modal
            isOpen={props.isModalOpen}
            contentLabel="Participate"
            className="modal-wrapper participateModal"
            style={{overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)'
                }}}
        >
            <div onClick={props.closeModal} >
                <SVGInline className="closeButton" svg={closeCrossSVG} component="i"/>
            </div>
            <div className="content middle">
                <div className="middlePart" onClick={()=>props.openSubmitModalRequest(SERVICE)}>
                    <SVGInline svg={tieMugicsSVG} component="i" className="icon-wrapper service" />
                    <div className="title">
                        {props.textService}
                    </div>
                    <p className="text">
                        Let's make some mugic businesses!
                    </p>
                </div>
            </div>

            <div className="content top">
                <div className="leftPart" onClick={()=>props.openSubmitModalRequest(LIVE_MUSIC)}>
                    <SVGInline svg={pianoPinkMugicsSVG} component="i" className="icon-wrapper" />
                    <div className="title">
                        {props.textLiveMusic}
                    </div>
                    <p className="text">
                        Don't die with your mugics still in you.
                    </p>
                </div>
            </div>
            <div className="content bottom">

                <div className="rightPart">
                    <div className="top-half" onClick={()=>props.openSubmitModalRequest(MUSICIAN)}>
                        <SVGInline svg={bandMugicsSVG} component="i" />
                        <div className="title">
                            {props.textMusician}
                        </div>
                        <p className="text">
                            תציע את עצמך ללהקות
                        </p>
                        <div className="round-icon" onClick={e => e.stopPropagation()}>
                            <SVGInline svg={scopWhiteTxtSVG} component="i" />
                        </div>
                    </div>
                    <div className="bottom-half" onClick={()=>props.openSubmitModalRequest(BAND)}>
                        <SVGInline svg={milkcartSVG} component="i" />
                        <div className="title">
                            {props.textBand}
                        </div>
                        <p className="text">
                            מצא מוזיקאי שיצטרף
                        </p>

                    </div>
                </div>
            </div>

        </Modal>
    </div>
);

export default ParticipateModal;



// WEBPACK FOOTER //
// ./src/Components/Users/Participate.js